import { Button, ButtonProps } from 'antd';
import { clsx } from 'clsx';
import { forwardRef } from 'react';

import s from './AntButton.module.less';

interface Props extends ButtonProps {
  noPadding?: boolean;
}

export const AntButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { noPadding, ...rest } = props;

  return <Button {...rest} className={clsx(s.wrapper, props.className, noPadding && s.noPadding)} ref={ref} />;
});

AntButton.displayName = 'AntButton';
